import { useCloseDealNegotiationMutation } from '@/lib/graphql/generated/graphql';
import { dealRefetchAtom } from '@/states/deal.state';
import { useAtomValue } from 'jotai';

export function useCloseNegotiation(dealId: string) {
  const dealRefetch = useAtomValue(dealRefetchAtom);
  const [closeDealNegotiationMutation, { loading, error }] =
    useCloseDealNegotiationMutation();

  const closeNegotiation = async () => {
    const result = await closeDealNegotiationMutation({
      variables: { dealId },
    });
    await dealRefetch.fn();
    return result;
  };

  return {
    closeNegotiation,
    loading,
    error,
  };
}
